module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', {
    attrs: {
      "header-bgc": true
    }
  }, [_c('template', {
    slot: "page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "price"
  }, _vm._l((_vm.priceData), function(price) {
    return _c('div', {
      staticClass: "price-item",
      class: price.icon
    }, [_c('div', {
      staticClass: "price-header"
    }, [_c('h3', [_vm._v(_vm._s(price.title))]), _vm._l((price.desc), function(desc) {
      return _c('p', [_vm._v(_vm._s(desc))])
    })], 2), _c('div', {
      staticClass: "price-body"
    }, [_c('ul', _vm._l((price.feature), function(feature) {
      return _c('li', [_c('span', {
        style: (feature.support || _vm.delStyle)
      }, [_vm._v(_vm._s(feature.type))]), (feature.content) ? _c('span', [_vm._v("（" + _vm._s(feature.content) + "）")]) : _vm._e()])
    }), 0), _c('p', {
      staticClass: "cost"
    }, _vm._l((price.price), function(price) {
      return _c('span', [_vm._v(_vm._s(price))])
    }), 0)]), _c('div', {
      staticClass: "price-footer"
    }, [_c('a', {
      attrs: {
        "href": "http://console.oncdp.com/#/login",
        "target": "_blank"
      }
    }, [_vm._v("立即购买")])])])
  }), 0)])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50bf916c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/price.vue
// module id = 47
// module chunks = 0